module.exports = __webpack_public_path__ + "static/media/din-sockets.374ef794.jpg";